import styled, { css } from 'styled-components';
import { DEFAULT_TRANSITION } from '../../constants';
export const Wrapper = styled.div `
  white-space: nowrap;
  margin-left: 30px;
  position: relative;

  & > a,
  & > span {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    ${({ theme }) => theme.typography.textMedium};
    padding: 12px;
    border-radius: 8px;
    transition: background-color ${DEFAULT_TRANSITION};
    background-color: ${({ $active, theme }) => $active && theme.colors.grey05_1};
    &:hover {
      background-color: ${({ theme }) => theme.colors.grey05_1};
    }
    ${({ $active, theme }) => $active &&
    css `
        ${theme.typography.weightMedium}
      `}
    color: ${({ $active, theme }) => ($active ? theme.colors.black_1 : theme.colors.grey100_1)}!important;
    cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};

    & > span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &:after {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    right: calc(100% + 4px);
    border-radius: 50%;
    background-color: ${({ $active, theme }) => ($active ? theme.colors.main : theme.colors.grey30_1)};
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  &:before {
    content: '';
    display: block;
    width: 1px;
    right: calc(100% + 6px);
    background-color: ${({ theme }) => theme.colors.grey10_1};
    position: absolute;
  }

  &:first-child {
    &:before {
      bottom: 0;
    }
  }

  &:not(:first-child) {
    &:before {
      top: 0;
    }
  }

  &:first-child:not(:last-child),
  &:last-child:not(:first-child) {
    &:before {
      height: 50%;
    }
  }

  &:not(:first-child):not(:last-child) {
    &:before {
      height: 100%;
    }
  }
`;
export const TagContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
`;
